import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NotificationUpdateCatalogIndexComponent } from '@component/notification/notification-update-catalog-index/notification-update-catalog-index.component';
import { DashboardMonitoringSheetKpiComponent } from '../../kpi/monitoring-sheet/dashboard-monitoring-sheet-kpi/dashboard-monitoring-sheet-kpi.component';
import { DashboardActionKpiComponent } from '@component/kpi/action/dashboard-action-kpi/dashboard-action-kpi.component';
import { StretchedCardDirective } from '@shared/directives/stretched-card.directive';
import { DashboardMonitoringSheetIndexComponent } from '../dashboard-monitoring-sheet-index/dashboard-monitoring-sheet-index.component';

@Component({
    selector: 'app-dashboard-connected-user',
    imports: [
        TranslateModule,
        NzDividerModule,
        NotificationUpdateCatalogIndexComponent,
        DashboardMonitoringSheetKpiComponent,
        DashboardActionKpiComponent,
        StretchedCardDirective,
        DashboardMonitoringSheetIndexComponent
    ],
    templateUrl: './dashboard-connected-user.component.html',
    styleUrl: './dashboard-connected-user.component.scss'
})
export class DashboardConnectedUserComponent {

    /**
     * dashboard monitoringsheet index visible status
     *
     * @public
     * @type {boolean}
     */
    public dashboardMonitoringsheetVisible: boolean = true;

    /**
    * Reset  the targeted component
    *
    * @public
    * @param {boolean} reset 
    */
    public handleReset(reset: boolean): void {
        if (reset) {
            this.dashboardMonitoringsheetVisible = false;
            setTimeout(() => {
                this.dashboardMonitoringsheetVisible = true;
            }, 0);
        }
    }

}
